export default __webpack_public_path__ + "static/media/1_tripadvisor.3f4a2b0c.svg";